@if (enableGAR && displayGARHelper && entButtonAllowed) {

    <button class="submit-button ent-help"
            (click)="onDisplayENTHelpClick()">
        <span>{{ "authentication.btn-login-gar" | translate }}</span>
    </button>

}